import { HStack, IconButton } from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoMdCheckmark } from 'react-icons/io';
import { LuMinus } from 'react-icons/lu';

import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';
import Tooltip from 'components/v4/Tooltip';
import ActionsCellWrapper from 'components/tables/AGGrid/ActionsCellWrapper';
import config from '@/config.json';

/**
 * Builds the AG Grid column definitions for the SBC table.
 *
 * @param {object}   params
 * @param {boolean}  params.darkMode   Current dark mode state.
 * @param {function} params.onEditSBC  Called with the row data when the edit action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getSBCTableColumns = ({ darkMode, onEditSBC }) => [
    {
        headerName: 'Priority',
        field: 'priority',
        width: 120,
        sort: 'asc',
    },
    {
        headerName: 'Name',
        field: 'name',
        cellRenderer: CopyCellRenderer,
        cellStyle: () => ({ width: '100%' }),
        flex: 1,
        minWidth: 200,
    },
    {
        headerName: 'Status',
        field: 'status',
        width: 160,
        valueFormatter: (params) =>
            config.sbc.statusJSON[params.value] ?? params.value,
    },
    {
        headerName: 'Active',
        field: 'isActive',
        width: 110,
        cellRenderer: (params) =>
            params.value ? (
                <IoMdCheckmark fontSize="large" />
            ) : (
                <LuMinus fontSize="large" />
            ),
        valueFormatter: (params) => (params.value ? 'Active' : 'Inactive'),
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({
            display: 'flex',
            alignItems: 'center',
        }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsCellWrapper>
                <HStack
                    spacing={0}
                    justifyContent="center"
                    alignItems="center"
                    width="100%"
                    height="100%">
                    <Tooltip label="Edit SBC">
                        <IconButton
                            icon={
                                <BsThreeDotsVertical
                                    fill={darkMode ? 'white' : 'black'}
                                />
                            }
                            aria-label="Edit"
                            variant="ghost"
                            onClick={() => {
                                onEditSBC(params.data);
                            }}
                            _hover={{
                                bg: darkMode
                                    ? 'whiteAlpha.200'
                                    : 'blackAlpha.100',
                            }}
                            _active={{
                                bg: darkMode
                                    ? 'whiteAlpha.300'
                                    : 'blackAlpha.200',
                            }}
                            _focus={{ boxShadow: 'none' }}
                        />
                    </Tooltip>
                </HStack>
            </ActionsCellWrapper>
        ),
    },
];
